var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNavegaciNConfiguraciN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.759.75v2.356c.737.31 1.433.71 2.07 1.191l2.037-1.176 3.757 6.508-2.005 1.157c.054.417.082.839.082 1.264 0 .393-.024.784-.07 1.17l1.993 1.151-3.757 6.508-1.961-1.133c-.659.506-1.38.926-2.146 1.248v2.256H8.245v-2.254c-.767-.322-1.49-.742-2.148-1.248l-1.96 1.13-3.756-6.507 1.989-1.148c-.047-.387-.07-.779-.07-1.173 0-.426.027-.849.081-1.266l-2-1.155L4.138 3.12 6.17 4.295c.64-.48 1.336-.881 2.074-1.191V.75h7.514zm-1.5 1.5H9.745v1.896l-.498.177c-.922.329-1.777.821-2.525 1.451l-.403.339-1.632-.943L2.43 9.08l1.608.928-.098.522c-.093.497-.14 1.005-.14 1.52 0 .486.042.966.125 1.437l.091.517-1.586.916 2.257 3.91 1.567-.905.403.346c.764.656 1.64 1.168 2.59 1.506l.498.177v1.796h4.514v-1.797l.498-.178c.948-.338 1.824-.85 2.586-1.505l.404-.347 1.57.907 2.257-3.91-1.59-.918.09-.517c.083-.47.125-.95.125-1.435 0-.514-.047-1.02-.14-1.518l-.097-.521 1.612-.931-2.257-3.91-1.635.945-.403-.34c-.747-.629-1.601-1.121-2.522-1.45l-.498-.178V2.25zm-2.26 5.215c2.508 0 4.541 2.033 4.541 4.54 0 2.508-2.033 4.541-4.54 4.541-2.508 0-4.541-2.033-4.541-4.54 0-2.508 2.033-4.541 4.54-4.541zm0 1.5c-1.679 0-3.04 1.361-3.04 3.04 0 1.68 1.361 3.041 3.04 3.041 1.68 0 3.041-1.361 3.041-3.04 0-1.68-1.361-3.041-3.04-3.041z",
    transform: "translate(-937 -485) translate(937 485)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavegaciNConfiguraciN);
export default __webpack_public_path__ + "static/media/icons-navegaci-n-configuraci-n.bc025577.svg";
export { ForwardRef as ReactComponent };